const TabsChakra = {
  sizes: {
    md: {
      tab: {
        fontSize: '16px',
        fontWeight: '700',
        paddingY: ['12px', '15px'],
      },
      tabpanel: {
        paddingY: '4',
        paddingX: '6',
      },
    },
  },
  variants: {
    colorful: {
      tab: {
        color: '#444E53',
        borderBottom: '4px solid #CBD7D9',
        _selected: {
          color: '#0092b0',
          borderBottom: '4px solid #0092b0',
        },
        _disabled: {
          color: '#d3d3d3',
        },
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'colorful',
  },
};

export default TabsChakra;
